module.exports = __webpack_public_path__ + "img/eScholar-logo-color.e951b57e.png";